/**
 * 将 PR 表格 operation 插槽拆成：留在卡片标题栏的「渠道色卡」与 顶栏/标题栏 的「下载等」
 */
export function partitionPrWorkspaceTableOperations(
  operation: unknown,
): { legendSlot: unknown[]; otherSlot: unknown[] } {
  const arr = Array.isArray(operation) ? operation : [];
  const legendSlot: unknown[] = [];
  const otherSlot: unknown[] = [];
  for (const item of arr) {
    if (item && typeof item === 'object' && (item as { name?: string }).name === 'PrChannelColorLegend') {
      legendSlot.push(item);
    } else {
      otherSlot.push(item);
    }
  }
  return { legendSlot, otherSlot };
}
